import { createSelector } from 'reselect';
import { getPublishedTourMedia } from './publishedTourSelector';

export const getMediaError = state => state.media.error;
export const getMedia = (state) => state.media;

export const getFullMedia = createSelector(
  [getMedia, getPublishedTourMedia],
  (media, publicTour) => {
    return {
      images: {
        ...publicTour.images,
        ...media.images,
      },
      videos: {
        ...publicTour.videos,
        ...media.videos,
      },
      videos360: {
        ...publicTour.videos360,
        ...media.videos360,
      },
      audio: {
        ...publicTour.audio,
        ...media.audio,
      },
      panos: {
        ...publicTour.panos,
        ...media.panos,
      },
    };
  }
);
